module.exports = __webpack_public_path__ + "img/clos-menu.8a015514.svg";